import { DATE_FORMAT, Tag } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type PeriodInterval } from '../models/periodInterval';

export const BudgetPeriodTag = ({ period }: { period: PeriodInterval }) => {
  const { localeFormat } = useTranslation('global');
  const formatDate = (date: Date) => localeFormat(date, DATE_FORMAT.MEDIUM);
  return (
    <Tag variant="carbon" className="text-content-primary" iconName="calendar">
      {`${formatDate(period.start)} - ${formatDate(period.end)}`}
    </Tag>
  );
};
